/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Reply_SentInputs */

const cs_messages_reply_sent = /** @type {(inputs: Messages_Reply_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpověď odeslána`)
};

const en_messages_reply_sent = /** @type {(inputs: Messages_Reply_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply sent`)
};

/**
* | output |
* | --- |
* | "Reply sent" |
*
* @param {Messages_Reply_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply_sent = /** @type {((inputs?: Messages_Reply_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Reply_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply_sent(inputs)
	return cs_messages_reply_sent(inputs)
});